import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Search, Calendar, User, Tag, ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { formatDate } from '../utils/helpers';
import { Blog as BlogType } from '../types';
import { blogAPI } from '../utils/api';

const Blog: React.FC = () => {
  const [blogs, setBlogs] = useState<BlogType[]>([]);
  const [allBlogs, setAllBlogs] = useState<BlogType[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTag, setSelectedTag] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalBlogs, setTotalBlogs] = useState(0);
  const blogsPerPage = 6;

  // Mock data for development (currently unused)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _mockBlogs: BlogType[] = [
    {
      id: '1',
      title: 'The Future of Web Development: Trends to Watch in 2024',
      slug: 'future-web-development-trends-2024',
      excerpt: 'Explore the latest trends shaping the future of web development, from AI integration to progressive web apps and beyond.',
      content: '',
      published: true,
      coverImage: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      tags: ['Web Development', 'Technology', 'Trends', '2025'],
      author: {
        id: '1',
        name: 'John Doe',
        email: 'john@infurasoft.com',
        role: 'admin',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z'
      },
      createdAt: '2024-01-15T00:00:00Z',
      updatedAt: '2024-01-15T00:00:00Z'
    },
    {
      id: '2',
      title: 'Mobile App Development: Native vs Cross-Platform',
      slug: 'mobile-app-development-native-vs-cross-platform',
      excerpt: 'A comprehensive comparison of native and cross-platform mobile development approaches to help you make the right choice.',
      content: '',
      published: true,
      coverImage: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      tags: ['Mobile Development', 'React Native', 'Flutter'],
      author: {
        id: '2',
        name: 'Jane Smith',
        email: 'jane@infurasoft.com',
        role: 'admin',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z'
      },
      createdAt: '2024-01-10T00:00:00Z',
      updatedAt: '2024-01-10T00:00:00Z'
    },
    {
      id: '3',
      title: 'SEO Best Practices for Modern Websites',
      slug: 'seo-best-practices-modern-websites',
      excerpt: 'Learn the essential SEO strategies that will help your website rank higher in search engines and attract more organic traffic.',
      content: '',
      published: true,
      coverImage: 'https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      tags: ['SEO', 'Digital Marketing', 'Content Strategy', "Google"],
      author: {
        id: '3',
        name: 'Mike Johnson',
        email: 'mike@infurasoft.com',
        role: 'admin',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z'
      },
      createdAt: '2024-01-05T00:00:00Z',
      updatedAt: '2024-01-05T00:00:00Z'
    },
    {
      id: '4',
      title: 'Building Scalable APIs with Node.js and Express',
      slug: 'building-scalable-apis-nodejs-express',
      excerpt: 'Discover the best practices for creating robust, scalable APIs using Node.js and Express framework.',
      content: '',
      published: true,
      coverImage: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      tags: ['Backend Development', 'Node.js', 'API Design'],
      author: {
        id: '4',
        name: 'Sarah Wilson',
        email: 'sarah@infurasoft.com',
        role: 'admin',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z'
      },
      createdAt: '2023-12-28T00:00:00Z',
      updatedAt: '2023-12-28T00:00:00Z'
    },
    {
      id: '5',
      title: 'The Power of TypeScript in Modern Development',
      slug: 'power-typescript-modern-development',
      excerpt: 'Understand how TypeScript can improve your development workflow and help you build more maintainable applications.',
      content: '',
      published: true,
      coverImage: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      tags: ['TypeScript', 'JavaScript', 'Development'],
      author: {
        id: '5',
        name: 'Alex Chen',
        email: 'alex@infurasoft.com',
        role: 'admin',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z'
      },
      createdAt: '2023-12-20T00:00:00Z',
      updatedAt: '2023-12-20T00:00:00Z'
    },
    {
      id: '6',
      title: 'Database Design Principles for Web Applications',
      slug: 'database-design-principles-web-applications',
      excerpt: 'Learn the fundamental principles of database design that will help you create efficient and scalable data structures.',
      content: '',
      published: true,
      coverImage: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      tags: ['Database', 'PostgreSQL', 'Data Modeling'],
      author: {
        id: '6',
        name: 'Emily Davis',
        email: 'emily@infurasoft.com',
        role: 'admin',
        createdAt: '2024-01-01T00:00:00Z',
        updatedAt: '2024-01-01T00:00:00Z'
      },
      createdAt: '2023-12-15T00:00:00Z',
      updatedAt: '2023-12-15T00:00:00Z'
    }
  ];

  const allTags = Array.from(new Set(allBlogs.flatMap(blog => blog.tags || [])));

  const fetchBlogs = useCallback(async () => {
    setLoading(true);
    try {
      const response = await blogAPI.getBlogs({ 
        page: currentPage, 
        limit: blogsPerPage, 
        search: searchTerm 
      });
      
      let filteredBlogs = response.data?.blogs || [];
      
      // Filter by tag on frontend since backend might not support tag filtering yet
      if (selectedTag) {
        filteredBlogs = filteredBlogs.filter((blog: BlogType) =>
          blog.tags && blog.tags.includes(selectedTag)
        );
      }
      
      setBlogs(filteredBlogs);
      setTotalBlogs(response.total || filteredBlogs.length);
      setTotalPages(response.totalPages || Math.ceil(filteredBlogs.length / blogsPerPage));
    } catch (error) {
      console.error('Error fetching blogs:', error);
      // Fallback to empty state on error
      setBlogs([]);
      setTotalBlogs(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm, selectedTag, blogsPerPage]);

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  // Fetch all blogs for tags (without pagination)
  useEffect(() => {
    const fetchAllBlogs = async () => {
      try {
        const response = await blogAPI.getBlogs({ limit: 1000 }); // Get all blogs for tags
        setAllBlogs(response.data?.blogs || []);
      } catch (error) {
        console.error('Error fetching all blogs for tags:', error);
      }
    };
    fetchAllBlogs();
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchBlogs();
  };

  const handleTagFilter = (tag: string) => {
    setSelectedTag(tag === selectedTag ? '' : tag);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`px-3 py-2 mx-1 rounded-lg ${
            currentPage === i
              ? 'bg-blue-600 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-gray-700'
          } transition-colors duration-200`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="flex items-center justify-center mt-12">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="flex items-center px-4 py-2 mx-1 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 rounded-lg hover:bg-blue-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
        >
          <ChevronLeft className="h-4 w-4 mr-1" />
          Previous
        </button>
        
        {pages}
        
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="flex items-center px-4 py-2 mx-1 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 rounded-lg hover:bg-blue-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
        >
          Next
          <ChevronRight className="h-4 w-4 ml-1" />
        </button>
      </div>
    );
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 text-white overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-12">
          <div className="text-center">
            <div className="mb-4">
              <span className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium text-blue-100 border border-white/30">
                📝 Latest Insights
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 leading-tight">
              Our <span className="text-blue-300 bg-gradient-to-r from-blue-300 to-cyan-300 bg-clip-text text-transparent">Blog</span>
            </h1>
            <p className="text-lg lg:text-xl mb-8 text-blue-100 leading-relaxed max-w-4xl mx-auto">
              Insights, tutorials, and industry trends from our team of experts. Stay updated with the latest in technology and digital innovation.
            </p>
            
            {/* Quick Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="text-2xl font-bold">50+</div>
                <div className="text-blue-200 text-sm">Articles</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="text-2xl font-bold">Weekly</div>
                <div className="text-blue-200 text-sm">Updates</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="text-2xl font-bold">Expert</div>
                <div className="text-blue-200 text-sm">Authors</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="text-2xl font-bold">Free</div>
                <div className="text-blue-200 text-sm">Resources</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-16 bg-gradient-to-br from-white via-gray-50/50 to-blue-50/30 dark:from-gray-900 dark:via-gray-800/50 dark:to-blue-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 items-center justify-between">
            {/* Search */}
            <form onSubmit={handleSearch} className="flex-1 max-w-md">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-indigo-600/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search articles..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-12 pr-4 py-4 border border-gray-200/50 dark:border-gray-600/50 rounded-2xl bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-lg hover:shadow-xl transition-all duration-300"
                  />
                </div>
              </div>
            </form>

            {/* Tag Filter */}
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => handleTagFilter('')}
                className={`group px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl ${
                  selectedTag === ''
                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white scale-105'
                    : 'bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-800 hover:scale-105 border border-gray-200/50 dark:border-gray-600/50'
                }`}
              >
                <span className="group-hover:scale-110 transition-transform duration-300 inline-block">
                  All
                </span>
              </button>
              {allTags.map((tag) => (
                <button
                  key={tag}
                  onClick={() => handleTagFilter(tag)}
                  className={`group px-6 py-3 rounded-2xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl ${
                    selectedTag === tag
                      ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white scale-105'
                      : 'bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-800 hover:scale-105 border border-gray-200/50 dark:border-gray-600/50'
                  }`}
                >
                  <span className="group-hover:scale-110 transition-transform duration-300 inline-block">
                    {tag}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* Results Info */}
          <div className="mt-8 text-center">
            <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-4 shadow-lg border border-gray-100/50 dark:border-gray-700/50">
              {loading ? (
                <div className="text-gray-600 dark:text-gray-400 font-medium">Loading articles...</div>
              ) : (
                <div className="text-gray-600 dark:text-gray-400 font-medium">
                  Showing <span className="text-blue-600 dark:text-blue-400 font-bold">{blogs.length}</span> of <span className="text-blue-600 dark:text-blue-400 font-bold">{totalBlogs}</span> articles{searchTerm ? ` for "${searchTerm}"` : ''}{selectedTag ? ` in "${selectedTag}"` : ''}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-12 bg-gradient-to-br from-gray-50 via-white to-indigo-50/30 dark:from-gray-800 dark:via-gray-900 dark:to-indigo-900/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[...Array(6)].map((_, index) => (
                <div key={index} className="bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm rounded-3xl overflow-hidden shadow-lg animate-pulse border border-gray-100/50 dark:border-gray-700/50">
                  <div className="h-48 bg-gray-300 dark:bg-gray-700"></div>
                  <div className="p-8">
                    <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
                    <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded mb-4 w-3/4"></div>
                    <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded mb-2"></div>
                    <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded mb-4 w-5/6"></div>
                    <div className="flex gap-2">
                      <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded-full w-16"></div>
                      <div className="h-6 bg-gray-300 dark:bg-gray-700 rounded-full w-20"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : blogs.length === 0 ? (
            <div className="text-center py-16">
              <div className="bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm rounded-3xl p-12 shadow-lg border border-gray-100/50 dark:border-gray-700/50">
                <div className="text-6xl mb-4">🔍</div>
                <div className="text-gray-500 dark:text-gray-400 text-xl font-medium">
                  No articles found. Try adjusting your search or filter criteria.
                </div>
                <p className="text-gray-400 dark:text-gray-500 mt-2">
                  Check back later for new content.
                </p>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogs.map((blog) => (
                <article key={blog.id} className="group relative bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100/50 dark:border-gray-700/50 hover:border-indigo-200 dark:hover:border-indigo-600 hover:-translate-y-3 hover:scale-105">
                  {/* Background Gradient */}
                  <div className="absolute inset-0 bg-gradient-to-br from-indigo-50/50 to-transparent dark:from-indigo-900/20 dark:to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <div className="relative z-10">
                    <div className="relative overflow-hidden">
                      <img
                        src={blog.coverImage}
                        alt={blog.title}
                        className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-500"></div>
                      <div className="absolute top-4 left-4">
                        <span className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-3 py-1 rounded-full text-sm font-medium shadow-lg">
                          {blog.tags[0]}
                        </span>
                      </div>
                      
                      {/* Floating Elements */}
                      <div className="absolute top-4 right-4 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-white text-sm animate-pulse">
                        📖
                      </div>
                    </div>
                    
                    <div className="p-8">
                      <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4 line-clamp-2 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors duration-300">
                        <Link
                          to={`/blog/${blog.slug}`}
                          className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors duration-300"
                        >
                          {blog.title}
                        </Link>
                      </h2>
                      
                      <p className="text-gray-600 dark:text-gray-300 mb-6 line-clamp-3 leading-relaxed group-hover:text-gray-700 dark:group-hover:text-gray-300 transition-colors duration-300">
                        {blog.excerpt}
                      </p>
                      
                      <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400 mb-6">
                        <div className="flex items-center bg-gray-50 dark:bg-gray-800 px-3 py-2 rounded-lg">
                          <User className="h-4 w-4 mr-2 text-indigo-600 dark:text-indigo-400" />
                          <span className="font-medium">{blog.author.name}</span>
                        </div>
                        <div className="flex items-center bg-gray-50 dark:bg-gray-800 px-3 py-2 rounded-lg">
                          <Calendar className="h-4 w-4 mr-2 text-indigo-600 dark:text-indigo-400" />
                          <span className="font-medium">{formatDate(blog.createdAt)}</span>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between">
                        <div className="flex flex-wrap gap-2">
                          {blog.tags.slice(1, 3).map((tag) => (
                            <span
                              key={tag}
                              className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-gradient-to-r from-indigo-100 to-purple-100 dark:from-indigo-900/50 dark:to-purple-900/50 text-indigo-800 dark:text-indigo-200 font-medium border border-indigo-200/50 dark:border-indigo-700/50 group-hover:scale-105 transition-transform duration-300"
                            >
                              <Tag className="h-3 w-3 mr-1" />
                              {tag}
                            </span>
                          ))}
                        </div>
                        
                        <Link
                          to={`/blog/${blog.slug}`}
                          className="group/btn inline-flex items-center text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 font-semibold transition-colors duration-300"
                        >
                          <span>Read More</span>
                          <ArrowRight className="h-4 w-4 ml-2 group-hover/btn:translate-x-1 transition-transform duration-300" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  
                  {/* Hover Effect Border */}
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-indigo-500/20 to-purple-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10 blur-xl"></div>
                </article>
              ))}
            </div>
          )}

          {/* Pagination */}
          {!loading && blogs.length > 0 && totalPages > 1 && renderPagination()}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="relative py-12 bg-gradient-to-br from-indigo-600 via-purple-700 to-pink-800 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>
        
        {/* Floating Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-white/5 rounded-full blur-2xl animate-bounce"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/10 rounded-full blur-xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8">
            <span className="inline-block px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium text-indigo-100 border border-white/30 mb-6">
              📧 Stay Updated
            </span>
          </div>
          
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Stay <span className="text-indigo-300 bg-gradient-to-r from-indigo-300 to-purple-300 bg-clip-text text-transparent">Updated</span>
          </h2>
          <p className="text-xl lg:text-2xl text-indigo-100 mb-12 max-w-4xl mx-auto leading-relaxed">
            Subscribe to our newsletter to get the latest insights, industry trends, and updates delivered directly to your inbox.
          </p>
          
          <form className="max-w-lg mx-auto flex gap-4 mb-12">
            <div className="flex-1 relative">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-6 py-4 rounded-2xl border-0 bg-white/90 backdrop-blur-sm text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-indigo-300 focus:outline-none shadow-lg"
                required
              />
            </div>
            <button
              type="submit"
              className="group px-8 py-4 bg-white text-indigo-600 font-semibold rounded-2xl hover:bg-indigo-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              <span>Subscribe</span>
            </button>
          </form>
          
          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-2">Weekly</div>
              <div className="text-indigo-200 text-sm">Insights</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-2">Industry</div>
              <div className="text-indigo-200 text-sm">Trends</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-2">Free</div>
              <div className="text-indigo-200 text-sm">Resources</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;